import { render } from "./HorisontalArrow.vue?vue&type=template&id=4a08fb48&scoped=true"
import script from "./HorisontalArrow.vue?vue&type=script&lang=js"
export * from "./HorisontalArrow.vue?vue&type=script&lang=js"

import "./HorisontalArrow.vue?vue&type=style&index=0&id=4a08fb48&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a08fb48"]])

export default __exports__